import {PaywallSlug} from './paywallEvents';

/**
 * The paywall on screen, recorded by `usePaywallAnalytics`, for shared infrastructure that fires paywall events
 * without being handed the slug (the Stripe loader and its fallback). Kept with the page it was set on, so after
 * navigating to a page that doesn't record one (e.g. /offer/:name) it reads null rather than the previous paywall.
 */
let activePaywall: {paywall: PaywallSlug; pathname: string} | null = null;

export const setActivePaywall = (paywall: PaywallSlug) => {
  activePaywall = {paywall, pathname: window.location.pathname};
};

export const getActivePaywall = (): PaywallSlug | null =>
  activePaywall && activePaywall.pathname === window.location.pathname ? activePaywall.paywall : null;
